import Highlighter from 'react-highlight-words';

interface HighlightTextProps {
  text: string;
  keyword?: string;
}

export default function HighlightText({ text, keyword }: HighlightTextProps) {
  if (!keyword?.trim()) return <>{text}</>;

  return (
    <Highlighter
      searchWords={[keyword.trim()]}
      autoEscape
      textToHighlight={text}
      highlightStyle={{ backgroundColor: '#FFD666' }}
    />
  );
}
